import aesReduxConstants from '../constants';
import productApi from '../apis/productApi';

const productActions = function(aesReduxConstants, productApi) {
  const actions = {};
  const constants = aesReduxConstants;
  actions.getAllProductTypesSuccess = function(products) {
    return {
      type: constants.GET_ALL_PRODUCTS_SUCCESS,
      products,
    };
  };

  actions.getAllProductTypesError = function(error) {
    return {
      type: constants.GET_ALL_PRODUCTS_SUCCESS,
      error,
    };
  };

  actions.getAllProductTypes = function() {
    return function(dispatch) {
      dispatch({ type: constants.GET_ALL_PRODUCTS });
      productApi.getAllProductTypes().then((response) => {
        dispatch(actions.getAllProductTypesSuccess(response.data.productList));
      }, (error) => {
        dispatch(actions.getAllProductTypesError(error.response.data));
      });
    };
  };

  return actions;
};

export default productActions(aesReduxConstants, productApi);
